import React, { useEffect, useState } from 'react'
import { Navbar, Nav } from 'react-bootstrap'
import '../App.css'
import WorkRoundedIcon from '@material-ui/icons/WorkRounded';
import CodeRoundedIcon from '@material-ui/icons/CodeRounded';
import AssessmentRoundedIcon from '@material-ui/icons/AssessmentRounded';
import PersonIcon from '@material-ui/icons/Person';

export const FooterMobile = () => {
    
    const path = window.location.href.toString().split('/')[window.location.href.toString().split('/').length-1]

    const pathId = window.location.href.toString().split('/')[window.location.href.toString().split('/').length-2]
    
    const [colorNav, setColorNav] = useState("rgb(66,135,245)")
    
    useEffect(()=>{
        switch(path){
            case "":
                setColorNav("rgb(66,135,245)")
                break;
            case "qualification":
                setColorNav("rgb(255,180,0)")
                break;
            case "projects":
                setColorNav("rgb(252,3,173)")
                break;
            case "hire":
                setColorNav("rgb(0,191,25)")
                break;
            default:
                setColorNav("rgb(252,3,173)")
                break;
                
        }
    },[])
    
    
    return (
        <Navbar style={{ fontSize:10, borderTop:"0.2px solid rgb(52,52,52)" }} fixed='bottom'>
            <Nav.Link href="/" className='mx-auto' id="icon">
                <PersonIcon style={path==="" ? { color:colorNav } : {color:"rgb(220,220,220)"}} />
            </Nav.Link>
            <Nav.Link href="/qualification" className='mx-auto' id="icon">
                <AssessmentRoundedIcon style={path==="qualification" ? { color:colorNav } : { color:"rgb(220,220,220)" }} />
            </Nav.Link>
            <Nav.Link href="/projects" className='mx-auto' id="icon">
                <CodeRoundedIcon style={path==="projects" && pathId!=="" ? { color:colorNav } : { color:"rgb(220,220,220)" }} />
            </Nav.Link>
            <Nav.Link href="/hire" className='mx-auto' id="icon">
                <WorkRoundedIcon style={path==="hire" ? { color:colorNav } : {color:"rgb(220,220,220)"}} />
            </Nav.Link>
        </Navbar>
    )
}
